import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';

import { AppHeader, SimpleModal } from '../../../components/common'
import { AppText, AppButton } from '../../../components/form';
import styles from './styles';

const PromItem = ({ label, coins, navigation }) => {
    const [ isDialogVisible, setDialogVisible ] = useState(false);
    const handleCoinClaim = () =>{
        setDialogVisible(false);
        navigation.navigate('Worker Claim Success', { coins })
    } 
    return (
        <AppButton style={styles.viewPromItem} onPress={()=>setDialogVisible(true)}><>
            <SimpleModal 
                visible={isDialogVisible} 
                onDismiss={()=>setDialogVisible(false)}
                title={'Confirmar Resgate'} 
                question={`Tem certeza que deseja resgatar ${coins} moedas por ${label}?`}
                onSIM={handleCoinClaim}
                onNAO={()=>setDialogVisible(false)}
            />
            <View style={[styles.viewPromItemTextContainer, styles.viewPromItemTextContainer]}>
                <AppText size='bold' style={styles.textPromItem}>{label}</AppText>
            </View>
            <View style={styles.viewCentered}>
                <AppText style={[styles.textPromItem, styles.textPromItemBigger ]}>{coins}</AppText>
                <AppText size='bold' style={[styles.textPromItem, styles.textPromItemSmaller]}>MOEDAS</AppText>
            </View>
            <View style={styles.viewCentered}>
                <Icon name='checkmark-circle-outline' style={styles.iconGo} />
            </View>
        </></AppButton>
    )
}

const CoinBank = ({ navigation }) => {
    return (
        <View style={styles.viewBase}>
            <AppHeader title={`Resgatar Moedas`} hasBack navigation={navigation} />
            <View style={styles.content}>
                <ScrollView style={styles.scrollview}>
                    <PromItem label={'1 Atendimento com Psicológico'} navigation={navigation} coins={600} />
                    <PromItem label={'1 Aula com Personal Trainer'} navigation={navigation} coins={1000} />
                    <PromItem label={'1 Atendimento com Nutricionista'} navigation={navigation} coins={900} />
                    <PromItem label={'1 Atendimento com Psicológico'} navigation={navigation} coins={600} />
                    <PromItem label={'1 Aula com Personal Trainer'} navigation={navigation} coins={1000} />
                    <PromItem label={'1 Atendimento com Nutricionista'} navigation={navigation} coins={900} />
                    <PromItem label={'1 Atendimento com Psicológico'} navigation={navigation} coins={600} />
                    <PromItem label={'1 Aula com Personal Trainer'} navigation={navigation} coins={1000} />
                    <PromItem label={'1 Atendimento com Nutricionista'} navigation={navigation} coins={900} />
                    <PromItem label={'1 Atendimento com Psicológico'} navigation={navigation} coins={600} />
                    <PromItem label={'1 Aula com Personal Trainer'} navigation={navigation} coins={1000} />
                    <PromItem label={'1 Atendimento com Nutricionista'} navigation={navigation} coins={900} />
                </ScrollView>
            </View>
        </View>
    )
}

export default CoinBank;